import { render, staticRenderFns } from "./SettingsFavInput.vue?vue&type=template&id=0f23bbb0&scoped=true&"
import script from "./SettingsFavInput.vue?vue&type=script&lang=js&"
export * from "./SettingsFavInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFavInput.vue?vue&type=style&index=0&id=0f23bbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23bbb0",
  null
  
)

component.options.__file = "SettingsFavInput.vue"
export default component.exports